define('maps/layers/focuslayer',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FocusLayer = void 0;
    var FocusLayer = /** @class */ (function () {
        function FocusLayer() {
        }
        FocusLayer.prototype.onAddGoogle = function (googleMap) {
            // Create marker
            this.marker = new google.maps.Marker({
                map: googleMap,
                position: { lat: 0, lng: 0 },
                visible: false
            });
        };
        FocusLayer.prototype.setFocus = function (point) {
            if (!this.marker)
                return;
            if (point && point.lat !== undefined && point.lng !== undefined) {
                // Update map marker
                this.marker.setPosition(point);
                this.marker.setVisible(true);
            }
            else {
                // Hide marker
                this.marker.setVisible(false);
            }
        };
        FocusLayer.prototype.onRemove = function () {
            if (this.marker) {
                this.marker.setMap(null);
                this.marker = undefined;
            }
        };
        return FocusLayer;
    }());
    exports.FocusLayer = FocusLayer;
});
//# sourceMappingURL=/assets/javascripts/maps/layers/focuslayer.js.map;
